import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CurrentDateWrapper, DueDate, Title } from './subcomponents';
import { translate } from '../../../strings/i18n';
var CurrentPaymentDueDate = function (_a) {
    var date = _a.date;
    return (_jsxs(CurrentDateWrapper, { children: [_jsx(Title, { children: translate('header.currentDueDate.title') }), _jsx(DueDate, { children: translate('header.currentDueDate.date', {
                    date: date
                }) })] }));
};
export default CurrentPaymentDueDate;
